import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { services } from '../utils/serviceData';
import PageSeparator from '../components/PageSeparator';
import SEO from '../components/SEO';

const serviceImages = [
  '/asset/img/case-1.png',
  '/asset/img/case-2.png',
  '/asset/img/case-3.png',
  '/asset/img/case-4.png',
  '/asset/img/case-5.png',
];

const ServicesPage = () => {
  const { t } = useTranslation();

  return (
    <main className="text-gray-900">
      <SEO 
        title="AlzijDigi | Onze Diensten"
        description="Ontdek AlzijDigi's uitgebreide digitale diensten inclusief op maat gemaakte software ontwikkeling, webapplicaties, mobiele apps en digitale marketing oplossingen."
        canonicalUrl="/diensten"
      />

      {/* Hero Section */}
      <section className="min-h-screen flex items-center pt-16">
        <div className="container mx-auto px-4 flex flex-col-reverse md:flex-row items-center gap-8">
          <div className="md:w-1/2">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">{t('services')}</h1>
            <p className="mb-8 text-lg md:text-xl max-w-prose leading-relaxed">{t('build_description')}</p>
            <Link
              to="#services-list"
              className="inline-block bg-emerald-800 text-white px-8 py-4 text-lg transition-transform hover:scale-105 hover:bg-emerald-700"
            >
              {t('view_cases')}
            </Link>
          </div>
          <div className="md:w-1/2 flex justify-center">
            <img
              src="/asset/img/diensten.png"
              alt="Alzijdigi logo"
              loading="lazy"
              className="w-3/4 max-w-md"
            />
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services-list" className="py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">{t('our_services')}</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">{t('services_subtitle')}</p>
          </div>

          <div className="space-y-16">
            {services.map((service, index) => (
              <div
                key={service.slug}
                className={`flex flex-col md:flex-row items-center gap-12 ${
                  index % 2 !== 0 ? 'md:flex-row-reverse' : ''
                }`}
              >
                {/* Image with service name overlay (mobile only) */}
                <div className="md:w-1/2 relative overflow-hidden h-80 rounded-lg shadow-lg order-first md:order-none">
                  <img
                    src={serviceImages[index % serviceImages.length]}
                    alt={t(service.titleKey)}
                    loading="lazy"
                    className="w-full h-full object-cover"
                  />
                  <div
  className="absolute top-0 left-0 p-4 md:hidden bg-neutral-500/10 backdrop-blur-xl border border-white/10 rounded-tl-lg"
  aria-hidden="true"
>
  <span className="font-bold text-black text-xl uppercase">
    {t(service.titleKey)}
  </span>
</div>

                </div>

                {/* Service text block */}
                <div className="md:w-1/2 group mt-4 md:mt-0">
                  <h3 className="text-2xl md:text-3xl font-bold mb-4 hidden md:block uppercase">
                    {t(service.titleKey)}
                  </h3>
                  <p className="text-gray-700 mb-6 text-lg leading-relaxed">
                    {t(service.contentKey)}
                  </p>
                  <Link
                    to={`/services/${service.slug}`}
                    className="inline-block text-emerald-800 font-semibold hover:underline text-lg"
                  >
                    {t('read_more')} →
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <PageSeparator />
    </main>
  );
};

export default ServicesPage;
